import 'react';
import 'reakit-system/useToken';
import 'color';
import './utils/isLight.js';
export { p as palette } from './ref-bbcfbae4.js';
export { useRoleProps } from './Role.js';
